<template>
    <v-card outlined class="card-format">
        <v-card-title class="mb-4 custom-title">
            PACKAGE
        </v-card-title>
        <v-card-text class="pa-0">
            <v-data-table :items="package_list" :headers="package_headers" hide-default-footer disable-pagination
                fixed-header height="500">
                <template v-slot:item="{ item }">
                    <tr @click="selected_package = item" class="package-row"
                        :class="{ 'selected-row': selected_package === item }">
                        <!-- Radio -->
                        <td class="py-1" style="width:40px;">
                            <input type="radio" :checked="selected_package === item">
                        </td>
                        <!-- Image -->
                        <td class="py-1" style="max-width:64px;">
                            <v-img v-if="item.image" :src="api_url + 'media/suppliers/images/' + item.image"
                                width="56" height="42" class="rounded" style="object-fit:cover;"></v-img>
                            <div v-else class="image-placeholder rounded">
                                <v-icon color="grey lighten-2" size="20">mdi-image-off-outline</v-icon>
                            </div>
                        </td>
                        <!-- Name / meta -->
                        <td>
                            <span class="font-weight-medium" style="font-size:0.875rem;">{{ item.name }}</span>
                            <div class="d-flex align-center mt-1" style="gap:6px;">
                                <v-chip x-small label v-if="item.type"
                                    :color="item.type === 'hen' ? 'pink lighten-4' : item.type === 'birthday' ? 'green lighten-4' : 'blue lighten-4'"
                                    :text-color="item.type === 'hen' ? 'pink darken-3' : item.type === 'birthday' ? 'green darken-3' : 'blue darken-3'"
                                    class="font-weight-medium text-capitalize">
                                    {{ item.type }}
                                </v-chip>
                                <span class="grey--text caption" v-if="item.nights != null">
                                    {{ item.nights }} night{{ item.nights !== 1 ? 's' : '' }}
                                </span>
                                <span class="grey--text caption" v-if="item.total_price">
                                    &bull; {{ get_selected_company.currency }}{{ item.total_price }}pp
                                </span>
                            </div>
                            <div v-if="item.short_description" class="grey--text mt-1"
                                style="font-size:11px;line-height:1.4;max-width:280px;"
                                v-html="item.short_description">
                            </div>
                        </td>
                        <!-- Location -->
                        <td style="width:120px;">
                            <span v-if="item.location" style="font-size:0.875rem;">{{ item.location.name }}</span>
                            <span v-else class="grey--text">—</span>
                        </td>
                        <!-- Activities -->
                        <td style="width:200px;">
                            <div v-for="(build, index) in item.builds.filter(x => x.type_id == 2)"  :key="index">
                                <div class="build-entry">
                                    <v-chip v-if="index === 0 || item.builds.filter(x => x.type_id == 2)[index - 1].day !== build.day"
                                        x-small label color="blue lighten-5" text-color="blue darken-2" class="mr-1"
                                        style="align-self:flex-start;">
                                        Day {{ build.day }}
                                    </v-chip>
                                    <span v-else class="mr-1" style="display:inline-block;width:42px;"></span>
                                    <span class="caption">{{ build.option ? build.option.name : build.supplier.supplier_name }}</span>
                                </div>
                            </div>
                            <span v-if="!item.builds.filter(x => x.type_id == 2).length" class="grey--text caption">—</span>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    <div class="py-8 text-center">
                        <v-icon size="40" color="grey lighten-2">mdi-package-variant-closed</v-icon>
                        <div class="mt-2 grey--text caption">No packages found</div>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions class="custom-buttons px-6 py-4">
            <v-spacer></v-spacer>
            <v-btn color="#252525" :dark="package_list.length > 0 && selected_package != null"
                :disabled="!(package_list.length > 0 && selected_package != null)"
                @click="save()">SAVE</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    components: {
    },
    props: [
        'lead', 'date_range', 'suppliers', 'edit_build', 'package_list'
    ],
    data: () => ({
        classes: {
        },
        package_headers: [
            { text: '', sortable: false, width: '40px' },
            { text: '', sortable: false, width: '64px' },
            { text: 'Name', value: 'name', width: '300px' },
            { text: 'Location', value: 'location.name', width: '120px' },
            { text: 'Activities', sortable: false, width: '200px' },
        ],
        selected_package: null,
        api_url: null,
    }),
    async mounted() {
        this.api_url = process.env.VUE_APP_API_URL
    },
    created() {
    },
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        }),
    },
    methods: {
        skip() {
            this.$emit('skip')
        },
        back() {
            this.$emit('back')
        },
        save() {
            this.$emit('save', this.selected_package, 0)
        },
    }
}
</script>

<style lang="scss" scoped>
.card-format {
    border-radius: 20px !important;
    overflow: hidden;
}

.custom-title {
    font-family: 'Manrope';
    font-size: 14px !important;
    color: #3988AA;
    font-weight: 600;
    padding-left: 24px;
    padding-top: 20px;
}

.package-row {
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: #F5FAFD !important;
    }

    td {
        font-family: Manrope;
    }
}

.selected-row {
    background-color: #EBF5FA !important;
}

.build-entry {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 2px;
}

.image-placeholder {
    width: 56px;
    height: 42px;
    background: #F5F5F5;
    display: flex;
    align-items: center;
    justify-content: center;
}

:deep(.custom-buttons span) {
    font-family: Manrope;
    font-size: 13px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
    width: 58px;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}
</style>